import posthog from "posthog-js";
import { recoverFromChunkError } from "@/lib/chunk-reload";

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
  api_host: "/ingest",
  ui_host: "https://us.posthog.com",
  defaults: "2026-01-30",
  capture_exceptions: true,
  debug: process.env.NODE_ENV === "development",
  // Keep startup lean: the session recorder (~52 KiB) is started later by
  // <DeferredAnalytics /> once the page is idle/interactive, and surveys
  // (~32 KiB) are unused in this app. Core capture/identify stay eager.
  disable_session_recording: true,
  disable_surveys: true,
});

// Chunk failures that happen outside render (a rejected `import()` from an
// effect, event handler or prefetch) never reach an error boundary — they
// surface as unhandled rejections. Reload for those too; the cooldown in
// recoverFromChunkError stops it looping. posthog's own listener still
// captures the event, so nothing is lost from error tracking.
window.addEventListener("unhandledrejection", (event) => {
  recoverFromChunkError(event.reason);
});
